module.exports = __webpack_public_path__ + "img/treatments-directory-notices-ru.d6bb4129.jpg";